import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import API from '../api';
import { verifyImpersonationTicket } from '../utils/auth';

const ImpersonateVerify = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('Verifying...');
    const [error, setError] = useState(null);
    const hasRunRef = useRef(false);

    useEffect(() => {
        // Ticket is single-use server-side; guard against any duplicate
        // invocation (React StrictMode double-effect in dev, fast re-nav, etc.)
        // so we never burn the ticket on a second, doomed-to-fail request.
        if (hasRunRef.current) return;
        hasRunRef.current = true;

        const run = async () => {
            const ticket = searchParams.get('ticket');
            if (!ticket) {
                setError('No ticket provided');
                return;
            }

            try {
                setStatus('Verifying ticket...');
                await verifyImpersonationTicket(API, ticket);
                // verifyImpersonationTicket handles redirect
                setStatus('Success! Redirecting...');
            } catch (err) {
                console.error(err);
                setError(err.message || 'Verification failed');
                setStatus('Error');
            }
        };
        run();
    }, [searchParams]);

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
                <div className="bg-white p-8 rounded shadow text-center max-w-md w-full">
                    <h1 className="text-xl font-bold text-red-600 mb-4">Impersonation Failed</h1>
                    <p className="text-gray-700 mb-6">{error}</p>
                    <button
                        onClick={() => window.close()}
                        className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                    >
                        Close Window
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mb-4"></div>
            <p className="text-gray-600 font-medium">{status}</p>
        </div>
    );
};

export default ImpersonateVerify;
